import React from 'react'
import { CBadge, CButton, CFormSelect } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilX } from '@coreui/icons'

// Barra de filtros rápidos GENÉRICA (patrón aprobado en Préstamos y
// Cierres/Egresos): selects de dominio + chips de filtros activos + Limpiar.
// Cada página provee su configuración (las grillas del GX traen filtros
// propios — prestamoww.cs:230, pagoww.cs:219, etc.).
export interface WwFilterSelect {
  key: string
  label: string            // opción "Todos..." (ej. "Todas las Rutas")
  opciones: string[]       // valores del dominio (endpoint real)
  valor: string
  onChange: (v: string) => void
}

export interface WwFilterChip {
  clave: string
  label: string
}

interface WwFilterBarProps {
  selects: WwFilterSelect[]
  chips: WwFilterChip[]
  onQuitar: (clave: string) => void
  onLimpiar: () => void
}

const WwFilterBar: React.FC<WwFilterBarProps> = ({ selects, chips, onQuitar, onLimpiar }) => (
  <div className="d-flex flex-wrap align-items-center gap-2 justify-content-end">
    {/* [RGM] 2026-09-17 (pedido Rafael): filtros de grilla alineados a la DERECHA. */}
    {selects.map((s) => (
      <CFormSelect
        key={s.key}
        className="w-auto"
        value={s.valor}
        onChange={(e) => s.onChange(e.target.value)}
      >
        <option value="">{s.label}</option>
        {s.opciones.map((o) => <option key={o} value={o}>{o}</option>)}
      </CFormSelect>
    ))}
    {chips.length > 0 && (
      <div className="d-flex flex-wrap align-items-center gap-1">
        {chips.map((f) => (
          <CBadge key={f.clave} color="secondary" className="d-inline-flex align-items-center gap-1 fw-normal">
            {f.label}
            <CIcon icon={cilX} size="sm" role="button" style={{ cursor: 'pointer' }} onClick={() => onQuitar(f.clave)} />
          </CBadge>
        ))}
        <CButton size="sm" color="outline-secondary" onClick={onLimpiar}>Limpiar filtros</CButton>
      </div>
    )}
  </div>
)

export default WwFilterBar
